import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  customers_settings_title_icon,
  online_booking_title_icon,
  sales_settings_title_icon,
  salon_general_settings_icon,
  services_title_icon,
  team_title_icon,
} from '../../assets/SVGs/SVGs';
type Props = {};

const Settings = (props: Props) => {
  const intl = useIntl();

  const data: any = [
    {
      svg: salon_general_settings_icon,
      title: intl.formatMessage({ id: 'salon_general_settings_title' }),
      description: intl.formatMessage({
        id: 'salon_general_settings_description',
      }),
      href: 'salon',
    },
    {
      svg: services_title_icon,
      title: intl.formatMessage({ id: 'services_title' }),
      description: intl.formatMessage({ id: 'services_description' }),
      href: 'services',
    },
    {
      svg: team_title_icon,
      title: intl.formatMessage({ id: 'team_title' }),
      description: intl.formatMessage({ id: 'team_description' }),
      href: '/team-members',
    },
    {
      svg: online_booking_title_icon,
      title: intl.formatMessage({ id: 'online_booking_title' }),
      description: intl.formatMessage({ id: 'online_booking_description' }),
      href: '/online-booking',
    },
    {
      svg: customers_settings_title_icon,
      title: intl.formatMessage({ id: 'customers_settings_title' }),
      description: intl.formatMessage({
        id: 'customers_settings_description',
      }),
      href: 'clients',
    },
    {
      svg: sales_settings_title_icon,
      title: intl.formatMessage({ id: 'sales_settings_title' }),
      description: intl.formatMessage({ id: 'sales_settings_description' }),
      href: 'sales',
    },
  ];
  return (
    <div className="grid grid-cols-1 gap-6 pb-2 -mt-2 sm:grid-cols-2 lg:grid-cols-3">
      {data?.map((e: any) => (
        <Link
          className="bg-white flex flex-col py-8 px-6 rounded-lg shadow-md gap-6 hover:bg-[#EEF0FF] transition-all duration-300 max-h-auto md:max-h-[250px]"
          to={e?.href}
        >
          <div>{e?.svg}</div>
          <div>
            <h5 className="text-lg font-semibold text-[#020418] mb-2">
              {e?.title}
            </h5>
            <p className="text-[#75757E] text-base font-normal">
              {e?.description}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Settings;
